module.exports = __webpack_public_path__ + "static/media/security-logos-jaywan.8529688e.png";